// src/components/quotes/useTicketPicklists.js
//
// THE ONE fetch of the Autotask ticket picklists for a modal, shared by the
// quote push modal and the onboarding tickets modal. One combined
// GET /api/tickets/reference call per `key` (the modal's quote/proposal id) —
// Autotask 500s when /Tickets/entityInformation/fields is hit concurrently,
// which is why the backend serves everything from one call and why a modal
// with N tickets must not fetch N times. Pass the result down as props.
//
// ⚠ This module imports the API client (and so MSAL). The pure shaping and
// lookup helpers live in ticketPicklists.js so components that only READ the
// lists never import this file. ⚠ DEGRADE, DON'T BLOCK: `error` is a flag the
// caller renders a quiet note for; it must never stop the action the modal
// exists for.
import { useEffect, useState } from "react";
import { getTicketReferenceData } from "../../api/ticketApi";
import { activeSorted } from "./ticketPicklists";

export { activeSorted, idOrNull, subIssuesFor } from "./ticketPicklists";

/**
 * @param key  something that identifies the modal's subject (a quote id or
 *             proposal id). null/undefined = do not fetch. A new key fetches
 *             again; the same key never re-fetches.
 * @returns { picklists: null | { issueTypes, subIssueTypes }, error: boolean }
 */
export function useTicketPicklists(key) {
  const [state, setState] = useState({ picklists: null, error: false });
  useEffect(() => {
    if (key === null || key === undefined) return undefined;
    let alive = true;
    setState({ picklists: null, error: false });
    (async () => {
      try {
        const d = await getTicketReferenceData();
        if (!alive) return;
        setState({ picklists: { issueTypes: activeSorted(d?.issueTypes), subIssueTypes: activeSorted(d?.subIssueTypes) }, error: false });
      } catch {
        if (alive) setState({ picklists: null, error: true });
      }
    })();
    return () => { alive = false; };
  }, [key]);
  return state;
}
